import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  selectAccessAuthorization,
  selectRefreshAuthorization,
  updateAccessToken,
} from "../../../features/login/loginSlice";
import { useEffect, useState } from "react";
import { Cookies } from "react-cookie";
import { ApiError, fetchWithResponse } from "../../../utils/EasyFetch";
import { LoginResponse } from "../../../features/login/types";
import { loading, notLoading } from "../../../features/loading/loadingSlice";
import { Task } from "../../../types/tasks";
import TaskPieChart from "./TaskPieChart";
import "./OverviewTasks.css";

const OverviewTasks = () => {
  const accessToken = useAppSelector(selectAccessAuthorization);
  const refreshToken = useAppSelector(selectRefreshAuthorization);
  const dispatch = useAppDispatch();
  const [tasks, setTasks] = useState<Task[]>([]);

  useEffect(() => {
    dispatch(loading());
    const cookies = new Cookies();
    fetchWithResponse<Task[]>(
      "GET",
      "/tasks",
      undefined,
      "Bearer " + accessToken
    )
      .then((t: Task[]) => {
        setTasks(t);
        dispatch(notLoading());
      })
      .catch((err: ApiError) => {
        if (err.statusCode === 401) {
          fetchWithResponse<LoginResponse>(
            "POST",
            "/auth/refresh",
            undefined,
            "Bearer " + refreshToken
          )
            .then((a: LoginResponse) => {
              cookies.set("accessToken", a.accessToken, {
                path: "/",
                sameSite: true,
              });
              dispatch(updateAccessToken(a.accessToken));
              dispatch(notLoading);
            })
            .catch(() => {
              dispatch(notLoading());
            });
        } else {
          dispatch(notLoading());
        }
      });
  }, [accessToken, dispatch, refreshToken]);

  const groupedTasks: Record<string, Task[]> = {};

  tasks.forEach((task) => {
    if (!groupedTasks[task.type]) {
      groupedTasks[task.type] = [];
    }
    groupedTasks[task.type].push(task);
  });

  return (
    <div className="overview-tasks__wrapper">
      <div className="overview-tasks__big-pie">
        <TaskPieChart tasks={tasks} name={"Total"} size="big" />
      </div>
      {Object.entries(groupedTasks).map(([type, tasks]) => (
        <div className="overview-tasks__small-pie">
          <TaskPieChart
            key={type}
            tasks={tasks}
            name={type.slice(0, -5)}
            size="small"
          />
        </div>
      ))}
    </div>
  );
};

export default OverviewTasks;
